import React, { forwardRef } from "react";
import { useNavigate } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { Shield, Users } from "lucide-react";
import { dateLocale } from "i18n";

const capitalizeWords = (str) =>
  str
    ?.split(" ")
    .map((word) => word.charAt(0).toUpperCase() + word.slice(1))
    .join(" ") || "";

const TeamRow = forwardRef(({ team, isLast }, ref) => {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const formatDate = (dateString) => {
    if (!dateString) return "-";
    const date = new Date(dateString);
    return date.toLocaleDateString(dateLocale("en-US"), {
      month: "short",
      day: "numeric",
      year: "numeric",
    });
  };

  const handleClick = () => {
    if (team.workspace_id) {
      navigate(`/v2/${team.workspace_id}/team/${team.id}`);
    }
  };

  return (
    <div
      ref={ref}
      onClick={handleClick}
      className={`flex cursor-pointer items-center justify-between px-4 py-3 transition duration-150 hover:bg-[#FAFAFA] ${
        !isLast ? "border-b border-[#F3F4F6]" : ""
      }`}
    >
      <div className="flex items-center gap-3">
        <div className="flex h-9 w-9 items-center justify-center rounded-lg bg-[#F3F4F6]">
          <Shield size={18} className="text-[#6B7280]" />
        </div>
        <div>
          <p className="text-sm font-medium text-[#111827]">{team.name}</p>
          <p className="text-xs text-[#6B7280]">{team.workspace_name || "-"}</p>
        </div>
      </div>

      <div className="flex items-center gap-6">
        {team.sport && (
          <span className="rounded bg-[#E0F2F1] px-1.5 py-0.5 text-[10px] font-medium text-[#00796B]">
            {capitalizeWords(team.sport)}
          </span>
        )}
        <div className="flex items-center gap-1.5 text-xs text-[#6B7280]">
          <Users size={12} />
          <span>
            {t("admin.superUser.teamRow.athleteCount", {
              total: team.player_count ?? 0,
            })}
          </span>
        </div>
        <span className="w-24 text-right text-xs text-[#9CA3AF]">
          {formatDate(team.created_at)}
        </span>
      </div>
    </div>
  );
});

TeamRow.displayName = "TeamRow";

export default TeamRow;
